import { useItem } from "../../../fetch/fetch.item.ts";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";

const ItemDate = ({ id }: { id: string }) => {
  const { item, isLoading, isError } = useItem(id, EMPTY_ITEM);
  if (isLoading) return "Datum...";
  if (isError) return isError;
  return new Date(item.updatedAt).toLocaleDateString("DE-de");
};
export default ItemDate;
